import { checkOrder, setCartProducts, formatTimeslots } from '@/utils/products/products';
import { useContext, useEffect, useState } from 'react';
import { PaymentOptionStore, ReplacementOptionStore } from '@/store/sideSheet';
import useBundleOffersSummary from './useBundleOffersSummary';
import { productsForOrder } from '@/store/cart';
import { convertFromCents, formatMoney } from '@/utils/amountUtils';
import { isEmpty } from 'lodash';
import { CurrencyContext } from '@/contexts/CurrencyProvider';
import { useTranslations } from 'next-intl';

export function useCheckOrderCheckout(
  setOrder,
  bags,
  paymentOptions,
  getCollectionTypes,
  selectedUserAddressIndex,
  setCartPrice,
  timeslotId,
  genericIndexes,
  genericTransformedTimeslots,
  noCommentToken,
  runCheck
) {
  const { bundleOffersSummary } = useBundleOffersSummary();
  const [paymentType, setPaymentType] = useState(PaymentOptionStore.getValue().type);
  const { formatter } = useContext(CurrencyContext);
  const t = useTranslations('common.asides');

  useEffect(() => {
    const paymentType$ = PaymentOptionStore.subscribe(setPaymentType);

    return () => {
      paymentType$.unsubscribe();
    };
  }, []);
  useEffect(() => {
    if (paymentType === undefined || isEmpty(genericIndexes) || !runCheck) return;
    checkOrder(
      setCartProducts(productsForOrder.getValue()),
      ReplacementOptionStore.getValue().option,
      false,
      getCollectionTypes(),
      selectedUserAddressIndex,
      bundleOffersSummary,
      bags,
      paymentOptions,
      formatTimeslots(genericTransformedTimeslots, genericIndexes),
      timeslotId,
      noCommentToken,
      formatter,
      undefined,
      t
    ).then(result => {
      if (result?.data?.order) {
        setOrder(result?.data?.order);
        setCartPrice(formatter.format(convertFromCents(result?.data?.order?.totalPrice)));
      }
    });
  }, [bags, paymentOptions, paymentType?.type, timeslotId, genericIndexes, runCheck]);
}
